module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "fill-height": ""
    }
  }, [_c('div', {
    style: (_vm.$vuetify.breakpoint.smAndUp ? 'position:absolute;top:10%;right:15%' : 'position:absolute;top:60px;right:10px')
  }, _vm._l((_vm.config.SUPPORTED_COUNTRIES), function(comm, c) {
    return _c('v-btn', {
      key: c,
      class: (_vm.commCountryCode === comm.country_code ? 'grey lighten-2 ' : '') + 'ma-0',
      attrs: {
        "fab": "",
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeCountry(comm.country_code, comm.country)
        }
      }
    }, [_c('flag', {
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "squared": false,
        "iso": comm.country_code.toLowerCase()
      }
    })], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "left-panel"
  }, [_c('img', {
    staticClass: "side-img",
    attrs: {
      "src": "/static/img/others/integrafms.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-panel d-flex align-center justify-center"
  }, [_c('div', {
    staticClass: "form-container text-xs-center"
  }, [_c('img', {
    attrs: {
      "height": "150",
      "width": "250",
      "src": "/static/img/logo/integra_logo.png"
    }
  }), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.joinComm.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": 'Search & join your community in ' + _vm.commLocConfig.country,
      "loading": _vm.loading,
      "items": _vm.items,
      "search-input": _vm.search,
      "no-data-text": _vm.search ? 'Community not found in our records' : 'Start typing your community name',
      "hide-details": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.selComm),
      callback: function($$v) {
        _vm.selComm = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "selComm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "block": "",
      "color": "primary"
    }
  }, [_vm._v("Join")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "accent",
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Already a member? Log in\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "flat": "",
      "small": "",
      "href": _vm.website_url
    }
  }, [_vm._v("\n            Contact Us\n          ")])], 1)], 1)])]), _vm._v(" "), (_vm.joining) ? _c('join-comm', {
    attrs: {
      "comm": _vm.selComm,
      "countrycode": _vm.commCountryCode,
      "country": _vm.commLocConfig.country
    },
    on: {
      "closed": function($event) {
        _vm.joining = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loging) ? _c('login', {
    attrs: {
      "countrycode": _vm.commCountryCode
    },
    on: {
      "closed": function($event) {
        _vm.loging = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a67123e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 763
// module chunks = 31